import { render, staticRenderFns } from "./ProjectAvatars.vue?vue&type=template&id=3528bbf4&"
import script from "./ProjectAvatars.vue?vue&type=script&lang=js&"
export * from "./ProjectAvatars.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAvatars.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports